// Top bar: sessions button + agent picker on the left; hands-free badge / mode toggles on the
// right. ChatPage decides whether the header renders at all (see `headerVisible`).
import { SpeakerIcon } from '@/components/chat/ChatIcons';

interface AgentOption {
  agent_id: string;
  agent_name: string;
}

export const ChatHeader = ({
  showSessionsBtn,
  showAgentPicker,
  agents,
  assistantId,
  onSelectAgent,
  onOpenSessions,
  showHandsFree,
}: {
  showSessionsBtn: boolean;
  showAgentPicker: boolean;
  agents: AgentOption[];
  assistantId: string;
  onSelectAgent: (id: string) => void;
  onOpenSessions: () => void;
  showHandsFree: boolean;
}) => (
  <div className="flex items-center justify-between gap-2 px-4 py-3 flex-shrink-0">
    <div className="flex items-center gap-2 min-w-0">
      {showSessionsBtn && (
        <button onClick={onOpenSessions} title="Chats" className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-ui-subtle border border-ui-border text-ui-text hover:bg-ui-hover transition">
          <span className="text-base leading-none">&#9776;</span> Chats
        </button>
      )}
      {showAgentPicker && (
        <select value={assistantId} onChange={(e) => onSelectAgent(e.target.value)} className="max-w-[180px] truncate rounded-full border border-ui-border bg-ui-subtle px-2.5 py-1.5 text-xs text-ui-text outline-none">
          {agents.map((a) => (
            <option key={a.agent_id} value={a.agent_id}>{a.agent_name}</option>
          ))}
        </select>
      )}
    </div>
    <div className="flex items-center gap-2">
      {showHandsFree && (
        <span className="flex items-center gap-1.5 text-xs px-3 py-1 rounded-full bg-ui-subtle border border-ui-border text-ui-text2">
          <SpeakerIcon className="h-3 w-3" /> Hands free
        </span>
      )}
    </div>
  </div>
);
